import { jsxs as ge, jsx as Te } from "react/jsx-runtime";
import Ke from "react";
import Ze from "../../layout/Stack/Stack.js";
import Ee from "../../layout/Box/Box.js";
import "styled-components";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
function Qe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ne = {}, He = { exports: {} }, Be = { exports: {} };
(function(e) {
  function s(o) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? (e.exports = s = function(r) {
      return typeof r;
    }, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = s = function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, e.exports.default = e.exports, e.exports.__esModule = !0), s(o);
  }
  e.exports = s, e.exports.default = e.exports, e.exports.__esModule = !0;
})(Be);
var Ge = Be.exports;
(function(e) {
  var s = Ge.default;
  function o() {
    if (typeof WeakMap != "function") return null;
    var r = /* @__PURE__ */ new WeakMap();
    return o = function() {
      return r;
    }, r;
  }
  function i(r) {
    if (r && r.__esModule)
      return r;
    if (r === null || s(r) !== "object" && typeof r != "function")
      return {
        default: r
      };
    var a = o();
    if (a && a.has(r))
      return a.get(r);
    var c = {}, l = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var x in r)
      if (Object.prototype.hasOwnProperty.call(r, x)) {
        var v = l ? Object.getOwnPropertyDescriptor(r, x) : null;
        v && (v.get || v.set) ? Object.defineProperty(c, x, v) : c[x] = r[x];
      }
    return c.default = r, a && a.set(r, c), c;
  }
  e.exports = i, e.exports.default = e.exports, e.exports.__esModule = !0;
})(He);
var er = He.exports, Ve = { exports: {} };
(function(e) {
  function s(o) {
    return o && o.__esModule ? o : {
      default: o
    };
  }
  e.exports = s, e.exports.default = e.exports, e.exports.__esModule = !0;
})(Ve);
var rr = Ve.exports, re = { exports: {} }, Oe;
function tr() {
  return Oe || (Oe = 1, function(e) {
    function s() {
      return e.exports = s = Object.assign || function(o) {
        for (var i = 1; i < arguments.length; i++) {
          var r = arguments[i];
          for (var a in r)
            Object.prototype.hasOwnProperty.call(r, a) && (o[a] = r[a]);
        }
        return o;
      }, e.exports.default = e.exports, e.exports.__esModule = !0, s.apply(this, arguments);
    }
    e.exports = s, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(re)), re.exports;
}
var te = { exports: {} }, ne = { exports: {} }, me;
function nr() {
  return me || (me = 1, function(e) {
    function s(o, i) {
      if (o == null) return {};
      var r = {}, a = Object.keys(o), c, l;
      for (l = 0; l < a.length; l++)
        c = a[l], !(i.indexOf(c) >= 0) && (r[c] = o[c]);
      return r;
    }
    e.exports = s, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(ne)), ne.exports;
}
var Pe;
function or() {
  return Pe || (Pe = 1, function(e) {
    var s = nr();
    function o(i, r) {
      if (i == null) return {};
      var a = s(i, r), c, l;
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(i);
        for (l = 0; l < x.length; l++)
          c = x[l], !(r.indexOf(c) >= 0) && Object.prototype.propertyIsEnumerable.call(i, c) && (a[c] = i[c]);
      }
      return a;
    }
    e.exports = o, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(te)), te.exports;
}
var oe = { exports: {} }, Re;
function ir() {
  return Re || (Re = 1, function(e) {
    function s(o, i) {
      if (!(o instanceof i))
        throw new TypeError("Cannot call a class as a function");
    }
    e.exports = s, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(oe)), oe.exports;
}
var ie = { exports: {} }, Ce;
function ar() {
  return Ce || (Ce = 1, function(e) {
    function s(i, r) {
      for (var a = 0; a < r.length; a++) {
        var c = r[a];
        c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(i, c.key, c);
      }
    }
    function o(i, r, a) {
      return r && s(i.prototype, r), a && s(i, a), i;
    }
    e.exports = o, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(ie)), ie.exports;
}
var ae = { exports: {} }, se = { exports: {} }, Se;
function Je() {
  return Se || (Se = 1, function(e) {
    function s(o) {
      if (o === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return o;
    }
    e.exports = s, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(se)), se.exports;
}
var we;
function sr() {
  return we || (we = 1, function(e) {
    var s = Ge.default, o = Je();
    function i(r, a) {
      return a && (s(a) === "object" || typeof a == "function") ? a : o(r);
    }
    e.exports = i, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(ae)), ae.exports;
}
var ue = { exports: {} }, Me;
function ur() {
  return Me || (Me = 1, function(e) {
    function s(o) {
      return e.exports = s = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
        return r.__proto__ || Object.getPrototypeOf(r);
      }, e.exports.default = e.exports, e.exports.__esModule = !0, s(o);
    }
    e.exports = s, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(ue)), ue.exports;
}
var fe = { exports: {} }, ce = { exports: {} }, qe;
function fr() {
  return qe || (qe = 1, function(e) {
    function s(o, i) {
      return e.exports = s = Object.setPrototypeOf || function(a, c) {
        return a.__proto__ = c, a;
      }, e.exports.default = e.exports, e.exports.__esModule = !0, s(o, i);
    }
    e.exports = s, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(ce)), ce.exports;
}
var Ie;
function cr() {
  return Ie || (Ie = 1, function(e) {
    var s = fr();
    function o(i, r) {
      if (typeof r != "function" && r !== null)
        throw new TypeError("Super expression must either be null or a function");
      i.prototype = Object.create(r && r.prototype, {
        constructor: {
          value: i,
          writable: !0,
          configurable: !0
        }
      }), r && s(i, r);
    }
    e.exports = o, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(fe)), fe.exports;
}
var le = { exports: {} }, Ae;
function lr() {
  return Ae || (Ae = 1, function(e) {
    function s(o, i, r) {
      return i in o ? Object.defineProperty(o, i, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : o[i] = r, o;
    }
    e.exports = s, e.exports.default = e.exports, e.exports.__esModule = !0;
  }(le)), le.exports;
}
var X = { exports: {} }, K = { exports: {} }, P = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var je;
function pr() {
  if (je) return P;
  je = 1;
  var e = typeof Symbol == "function" && Symbol.for, s = e ? Symbol.for("react.element") : 60103, o = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, x = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, E = e ? Symbol.for("react.forward_ref") : 60112, b = e ? Symbol.for("react.suspense") : 60113, M = e ? Symbol.for("react.suspense_list") : 60120, w = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, q = e ? Symbol.for("react.block") : 60121, A = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, j = e ? Symbol.for("react.scope") : 60119;
  function p(t) {
    if (typeof t == "object" && t !== null) {
      var W = t.$$typeof;
      switch (W) {
        case s:
          switch (t = t.type, t) {
            case x:
            case v:
            case i:
            case a:
            case r:
            case b:
              return t;
            default:
              switch (t = t && t.$$typeof, t) {
                case l:
                case E:
                case $:
                case w:
                case c:
                  return t;
                default:
                  return W;
              }
          }
        case o:
          return W;
      }
    }
  }
  function d(t) {
    return p(t) === v;
  }
  return P.AsyncMode = x, P.ConcurrentMode = v, P.ContextConsumer = l, P.ContextProvider = c, P.Element = s, P.ForwardRef = E, P.Fragment = i, P.Lazy = $, P.Memo = w, P.Portal = o, P.Profiler = a, P.StrictMode = r, P.Suspense = b, P.isAsyncMode = function(t) {
    return d(t) || p(t) === x;
  }, P.isConcurrentMode = d, P.isContextConsumer = function(t) {
    return p(t) === l;
  }, P.isContextProvider = function(t) {
    return p(t) === c;
  }, P.isElement = function(t) {
    return typeof t == "object" && t !== null && t.$$typeof === s;
  }, P.isForwardRef = function(t) {
    return p(t) === E;
  }, P.isFragment = function(t) {
    return p(t) === i;
  }, P.isLazy = function(t) {
    return p(t) === $;
  }, P.isMemo = function(t) {
    return p(t) === w;
  }, P.isPortal = function(t) {
    return p(t) === o;
  }, P.isProfiler = function(t) {
    return p(t) === a;
  }, P.isStrictMode = function(t) {
    return p(t) === r;
  }, P.isSuspense = function(t) {
    return p(t) === b;
  }, P.isValidElementType = function(t) {
    return typeof t == "string" || typeof t == "function" || t === i || t === v || t === a || t === r || t === b || t === M || typeof t == "object" && t !== null && (t.$$typeof === $ || t.$$typeof === w || t.$$typeof === c || t.$$typeof === l || t.$$typeof === E || t.$$typeof === A || t.$$typeof === I || t.$$typeof === j || t.$$typeof === q);
  }, P.typeOf = p, P;
}
var R = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var We;
function dr() {
  return We || (We = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, s = e ? Symbol.for("react.element") : 60103, o = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, x = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, E = e ? Symbol.for("react.forward_ref") : 60112, b = e ? Symbol.for("react.suspense") : 60113, M = e ? Symbol.for("react.suspense_list") : 60120, w = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, q = e ? Symbol.for("react.block") : 60121, A = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, j = e ? Symbol.for("react.scope") : 60119;
    function p(u) {
      return typeof u == "string" || typeof u == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      u === i || u === v || u === a || u === r || u === b || u === M || typeof u == "object" && u !== null && (u.$$typeof === $ || u.$$typeof === w || u.$$typeof === c || u.$$typeof === l || u.$$typeof === E || u.$$typeof === A || u.$$typeof === I || u.$$typeof === j || u.$$typeof === q);
    }
    function d(u) {
      if (typeof u == "object" && u !== null) {
        var ee = u.$$typeof;
        switch (ee) {
          case s:
            var J = u.type;
            switch (J) {
              case x:
              case v:
              case i:
              case a:
              case r:
              case b:
                return J;
              default:
                var be = J && J.$$typeof;
                switch (be) {
                  case l:
                  case E:
                  case $:
                  case w:
                  case c:
                    return be;
                  default:
                    return ee;
                }
            }
          case o:
            return ee;
        }
      }
    }
    var t = x, W = v, D = l, z = c, k = s, N = E, H = i, B = $, U = w, Z = o, Y = a, G = r, Q = b, V = !1;
    function n(u) {
      return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), f(u) || d(u) === x;
    }
    function f(u) {
      return d(u) === v;
    }
    function T(u) {
      return d(u) === l;
    }
    function g(u) {
      return d(u) === c;
    }
    function y(u) {
      return typeof u == "object" && u !== null && u.$$typeof === s;
    }
    function m(u) {
      return d(u) === E;
    }
    function _(u) {
      return d(u) === i;
    }
    function h(u) {
      return d(u) === $;
    }
    function O(u) {
      return d(u) === w;
    }
    function C(u) {
      return d(u) === o;
    }
    function S(u) {
      return d(u) === a;
    }
    function F(u) {
      return d(u) === r;
    }
    function L(u) {
      return d(u) === b;
    }
    R.AsyncMode = t, R.ConcurrentMode = W, R.ContextConsumer = D, R.ContextProvider = z, R.Element = k, R.ForwardRef = N, R.Fragment = H, R.Lazy = B, R.Memo = U, R.Portal = Z, R.Profiler = Y, R.StrictMode = G, R.Suspense = Q, R.isAsyncMode = n, R.isConcurrentMode = f, R.isContextConsumer = T, R.isContextProvider = g, R.isElement = y, R.isForwardRef = m, R.isFragment = _, R.isLazy = h, R.isMemo = O, R.isPortal = C, R.isProfiler = S, R.isStrictMode = F, R.isSuspense = L, R.isValidElementType = p, R.typeOf = d;
  }()), R;
}
var $e;
function Xe() {
  return $e || ($e = 1, process.env.NODE_ENV === "production" ? K.exports = pr() : K.exports = dr()), K.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var pe, ke;
function vr() {
  if (ke) return pe;
  ke = 1;
  var e = Object.getOwnPropertySymbols, s = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
  function i(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function r() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var c = {}, l = 0; l < 10; l++)
        c["_" + String.fromCharCode(l)] = l;
      var x = Object.getOwnPropertyNames(c).map(function(E) {
        return c[E];
      });
      if (x.join("") !== "0123456789")
        return !1;
      var v = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(E) {
        v[E] = E;
      }), Object.keys(Object.assign({}, v)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return pe = r() ? Object.assign : function(a, c) {
    for (var l, x = i(a), v, E = 1; E < arguments.length; E++) {
      l = Object(arguments[E]);
      for (var b in l)
        s.call(l, b) && (x[b] = l[b]);
      if (e) {
        v = e(l);
        for (var M = 0; M < v.length; M++)
          o.call(l, v[M]) && (x[v[M]] = l[v[M]]);
      }
    }
    return x;
  }, pe;
}
var de, De;
function xe() {
  if (De) return de;
  De = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return de = e, de;
}
var ve, Le;
function yr() {
  if (Le) return ve;
  Le = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var s = xe(), o = {}, i = Function.call.bind(Object.prototype.hasOwnProperty);
    e = function(a) {
      var c = "Warning: " + a;
      typeof console < "u" && console.error(c);
      try {
        throw new Error(c);
      } catch {
      }
    };
  }
  function r(a, c, l, x, v) {
    if (process.env.NODE_ENV !== "production") {
      for (var E in a)
        if (i(a, E)) {
          var b;
          try {
            if (typeof a[E] != "function") {
              var M = Error(
                (x || "React class") + ": " + l + " type `" + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[E] + "`."
              );
              throw M.name = "Invariant Violation", M;
            }
            b = a[E](c, E, x, l, null, s);
          } catch ($) {
            b = $;
          }
          if (b && !(b instanceof Error) && e(
            (x || "React class") + ": type specification of " + l + " `" + E + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof b + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), b instanceof Error && !(b.message in o)) {
            o[b.message] = !0;
            var w = v ? v() : "";
            e(
              "Failed " + l + " type: " + b.message + (w ?? "")
            );
          }
        }
    }
  }
  return r.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (o = {});
  }, ve = r, ve;
}
var ye, Ye;
function hr() {
  if (Ye) return ye;
  Ye = 1;
  var e = Xe(), s = vr(), o = xe(), i = yr(), r = Function.call.bind(Object.prototype.hasOwnProperty), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(l) {
    var x = "Warning: " + l;
    typeof console < "u" && console.error(x);
    try {
      throw new Error(x);
    } catch {
    }
  });
  function c() {
    return null;
  }
  return ye = function(l, x) {
    var v = typeof Symbol == "function" && Symbol.iterator, E = "@@iterator";
    function b(n) {
      var f = n && (v && n[v] || n[E]);
      if (typeof f == "function")
        return f;
    }
    var M = "<<anonymous>>", w = {
      array: I("array"),
      bool: I("boolean"),
      func: I("function"),
      number: I("number"),
      object: I("object"),
      string: I("string"),
      symbol: I("symbol"),
      any: j(),
      arrayOf: p,
      element: d(),
      elementType: t(),
      instanceOf: W,
      node: N(),
      objectOf: z,
      oneOf: D,
      oneOfType: k,
      shape: H,
      exact: B
    };
    function $(n, f) {
      return n === f ? n !== 0 || 1 / n === 1 / f : n !== n && f !== f;
    }
    function q(n) {
      this.message = n, this.stack = "";
    }
    q.prototype = Error.prototype;
    function A(n) {
      if (process.env.NODE_ENV !== "production")
        var f = {}, T = 0;
      function g(m, _, h, O, C, S, F) {
        if (O = O || M, S = S || h, F !== o) {
          if (x) {
            var L = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw L.name = "Invariant Violation", L;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var u = O + ":" + h;
            !f[u] && // Avoid spamming the console because they are often not actionable except for lib authors
            T < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + S + "` prop on `" + O + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), f[u] = !0, T++);
          }
        }
        return _[h] == null ? m ? _[h] === null ? new q("The " + C + " `" + S + "` is marked as required " + ("in `" + O + "`, but its value is `null`.")) : new q("The " + C + " `" + S + "` is marked as required in " + ("`" + O + "`, but its value is `undefined`.")) : null : n(_, h, O, C, S);
      }
      var y = g.bind(null, !1);
      return y.isRequired = g.bind(null, !0), y;
    }
    function I(n) {
      function f(T, g, y, m, _, h) {
        var O = T[g], C = Y(O);
        if (C !== n) {
          var S = G(O);
          return new q("Invalid " + m + " `" + _ + "` of type " + ("`" + S + "` supplied to `" + y + "`, expected ") + ("`" + n + "`."));
        }
        return null;
      }
      return A(f);
    }
    function j() {
      return A(c);
    }
    function p(n) {
      function f(T, g, y, m, _) {
        if (typeof n != "function")
          return new q("Property `" + _ + "` of component `" + y + "` has invalid PropType notation inside arrayOf.");
        var h = T[g];
        if (!Array.isArray(h)) {
          var O = Y(h);
          return new q("Invalid " + m + " `" + _ + "` of type " + ("`" + O + "` supplied to `" + y + "`, expected an array."));
        }
        for (var C = 0; C < h.length; C++) {
          var S = n(h, C, y, m, _ + "[" + C + "]", o);
          if (S instanceof Error)
            return S;
        }
        return null;
      }
      return A(f);
    }
    function d() {
      function n(f, T, g, y, m) {
        var _ = f[T];
        if (!l(_)) {
          var h = Y(_);
          return new q("Invalid " + y + " `" + m + "` of type " + ("`" + h + "` supplied to `" + g + "`, expected a single ReactElement."));
        }
        return null;
      }
      return A(n);
    }
    function t() {
      function n(f, T, g, y, m) {
        var _ = f[T];
        if (!e.isValidElementType(_)) {
          var h = Y(_);
          return new q("Invalid " + y + " `" + m + "` of type " + ("`" + h + "` supplied to `" + g + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return A(n);
    }
    function W(n) {
      function f(T, g, y, m, _) {
        if (!(T[g] instanceof n)) {
          var h = n.name || M, O = V(T[g]);
          return new q("Invalid " + m + " `" + _ + "` of type " + ("`" + O + "` supplied to `" + y + "`, expected ") + ("instance of `" + h + "`."));
        }
        return null;
      }
      return A(f);
    }
    function D(n) {
      if (!Array.isArray(n))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), c;
      function f(T, g, y, m, _) {
        for (var h = T[g], O = 0; O < n.length; O++)
          if ($(h, n[O]))
            return null;
        var C = JSON.stringify(n, function(F, L) {
          var u = G(L);
          return u === "symbol" ? String(L) : L;
        });
        return new q("Invalid " + m + " `" + _ + "` of value `" + String(h) + "` " + ("supplied to `" + y + "`, expected one of " + C + "."));
      }
      return A(f);
    }
    function z(n) {
      function f(T, g, y, m, _) {
        if (typeof n != "function")
          return new q("Property `" + _ + "` of component `" + y + "` has invalid PropType notation inside objectOf.");
        var h = T[g], O = Y(h);
        if (O !== "object")
          return new q("Invalid " + m + " `" + _ + "` of type " + ("`" + O + "` supplied to `" + y + "`, expected an object."));
        for (var C in h)
          if (r(h, C)) {
            var S = n(h, C, y, m, _ + "." + C, o);
            if (S instanceof Error)
              return S;
          }
        return null;
      }
      return A(f);
    }
    function k(n) {
      if (!Array.isArray(n))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), c;
      for (var f = 0; f < n.length; f++) {
        var T = n[f];
        if (typeof T != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Q(T) + " at index " + f + "."
          ), c;
      }
      function g(y, m, _, h, O) {
        for (var C = 0; C < n.length; C++) {
          var S = n[C];
          if (S(y, m, _, h, O, o) == null)
            return null;
        }
        return new q("Invalid " + h + " `" + O + "` supplied to " + ("`" + _ + "`."));
      }
      return A(g);
    }
    function N() {
      function n(f, T, g, y, m) {
        return U(f[T]) ? null : new q("Invalid " + y + " `" + m + "` supplied to " + ("`" + g + "`, expected a ReactNode."));
      }
      return A(n);
    }
    function H(n) {
      function f(T, g, y, m, _) {
        var h = T[g], O = Y(h);
        if (O !== "object")
          return new q("Invalid " + m + " `" + _ + "` of type `" + O + "` " + ("supplied to `" + y + "`, expected `object`."));
        for (var C in n) {
          var S = n[C];
          if (S) {
            var F = S(h, C, y, m, _ + "." + C, o);
            if (F)
              return F;
          }
        }
        return null;
      }
      return A(f);
    }
    function B(n) {
      function f(T, g, y, m, _) {
        var h = T[g], O = Y(h);
        if (O !== "object")
          return new q("Invalid " + m + " `" + _ + "` of type `" + O + "` " + ("supplied to `" + y + "`, expected `object`."));
        var C = s({}, T[g], n);
        for (var S in C) {
          var F = n[S];
          if (!F)
            return new q(
              "Invalid " + m + " `" + _ + "` key `" + S + "` supplied to `" + y + "`.\nBad object: " + JSON.stringify(T[g], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(n), null, "  ")
            );
          var L = F(h, S, y, m, _ + "." + S, o);
          if (L)
            return L;
        }
        return null;
      }
      return A(f);
    }
    function U(n) {
      switch (typeof n) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !n;
        case "object":
          if (Array.isArray(n))
            return n.every(U);
          if (n === null || l(n))
            return !0;
          var f = b(n);
          if (f) {
            var T = f.call(n), g;
            if (f !== n.entries) {
              for (; !(g = T.next()).done; )
                if (!U(g.value))
                  return !1;
            } else
              for (; !(g = T.next()).done; ) {
                var y = g.value;
                if (y && !U(y[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Z(n, f) {
      return n === "symbol" ? !0 : f ? f["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && f instanceof Symbol : !1;
    }
    function Y(n) {
      var f = typeof n;
      return Array.isArray(n) ? "array" : n instanceof RegExp ? "object" : Z(f, n) ? "symbol" : f;
    }
    function G(n) {
      if (typeof n > "u" || n === null)
        return "" + n;
      var f = Y(n);
      if (f === "object") {
        if (n instanceof Date)
          return "date";
        if (n instanceof RegExp)
          return "regexp";
      }
      return f;
    }
    function Q(n) {
      var f = G(n);
      switch (f) {
        case "array":
        case "object":
          return "an " + f;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + f;
        default:
          return f;
      }
    }
    function V(n) {
      return !n.constructor || !n.constructor.name ? M : n.constructor.name;
    }
    return w.checkPropTypes = i, w.resetWarningCache = i.resetWarningCache, w.PropTypes = w, w;
  }, ye;
}
var he, Fe;
function _r() {
  if (Fe) return he;
  Fe = 1;
  var e = xe();
  function s() {
  }
  function o() {
  }
  return o.resetWarningCache = s, he = function() {
    function i(c, l, x, v, E, b) {
      if (b !== e) {
        var M = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw M.name = "Invariant Violation", M;
      }
    }
    i.isRequired = i;
    function r() {
      return i;
    }
    var a = {
      array: i,
      bool: i,
      func: i,
      number: i,
      object: i,
      string: i,
      symbol: i,
      any: i,
      arrayOf: r,
      element: i,
      elementType: i,
      instanceOf: r,
      node: i,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: o,
      resetWarningCache: s
    };
    return a.PropTypes = a, a;
  }, he;
}
var ze;
function xr() {
  if (ze) return X.exports;
  if (ze = 1, process.env.NODE_ENV !== "production") {
    var e = Xe(), s = !0;
    X.exports = hr()(e.isElement, s);
  } else
    X.exports = _r()();
  return X.exports;
}
var _e = {}, Ue;
function br() {
  return Ue || (Ue = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = s;
    function s(o) {
      var i = /(\d+(?:\.\d+)?|\.\d+)(m?s)\b/i.exec(o);
      if (!i) throw new Error("Could not parse time from transition value");
      return Number(i[1]) * (i[2].length === 1 ? 1e3 : 1);
    }
  }(_e)), _e;
}
(function(e) {
  var s = er, o = rr;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var i = o(tr()), r = o(or()), a = o(ir()), c = o(ar()), l = o(sr()), x = o(ur()), v = o(Je()), E = o(cr()), b = o(lr()), M = s(Ke), w = o(xr()), $ = o(br()), q = /* @__PURE__ */ function(A) {
    (0, E.default)(I, A);
    function I(j) {
      var p;
      return (0, a.default)(this, I), p = (0, l.default)(this, (0, x.default)(I).call(this, j)), (0, b.default)((0, v.default)(p), "_removeTransitionEndListener", function() {
      }), (0, b.default)((0, v.default)(p), "_main", M.createRef()), (0, b.default)((0, v.default)(p), "_inner", M.createRef()), (0, b.default)((0, v.default)(p), "_onNextTransitionEnd", function(d, t) {
        p._removeTransitionEndListener();
        var W = function() {
          p._removeTransitionEndListener(), t();
        }, D;
        p._removeTransitionEndListener = function() {
          p._removeTransitionEndListener = function() {
          }, clearTimeout(D), d.removeEventListener("transitionend", W);
        }, d.addEventListener("transitionend", W);
        var z = (0, $.default)(p.props.heightTransition) * 1.1 + 500;
        D = setTimeout(W, z);
      }), p.state = {
        renderInner: j.expanded || I._visibleWhenClosed(j),
        closing: !1,
        fullyClosed: !j.expanded,
        height: j.expanded ? "auto" : j.collapsedHeight
      }, p;
    }
    return (0, c.default)(I, [{
      key: "componentWillUnmount",
      value: function() {
        this._removeTransitionEndListener();
      }
    }, {
      key: "componentDidUpdate",
      value: function(p, d) {
        var t = this;
        if (!p.expanded && this.props.expanded) {
          this._removeTransitionEndListener();
          var W = this._main.current, D = this._inner.current;
          if (!W || !D) throw new Error("Should not happen");
          var z = "".concat(D.clientHeight, "px");
          this.setState({
            height: z
          }), this._onNextTransitionEnd(W, function() {
            t.setState({
              height: "auto"
            }, function() {
              t.props.onChangeEnd && t.props.onChangeEnd();
            });
          });
        } else if (p.expanded && !this.props.expanded) {
          if (this._removeTransitionEndListener(), !this._inner.current) throw new Error("Should not happen");
          this.setState({
            height: "".concat(this._inner.current.clientHeight, "px")
          }, function() {
            var k = t._main.current;
            if (!k) throw new Error("Should not happen");
            k.clientHeight, t.setState({
              height: t.props.collapsedHeight,
              closing: !0
            }), t._onNextTransitionEnd(k, function() {
              t.setState({
                closing: !1,
                fullyClosed: !0
              }), t.props.onChangeEnd && t.props.onChangeEnd();
            });
          });
        }
      }
    }, {
      key: "render",
      value: function() {
        var p = I._visibleWhenClosed(this.props), d = this.props, t = d.allowOverflowWhenOpen, W = d.children;
        d.collapsedHeight, d.eagerRender, d.expanded;
        var D = d.heightTransition;
        d.onChangeEnd;
        var z = (0, r.default)(d, ["allowOverflowWhenOpen", "children", "collapsedHeight", "eagerRender", "expanded", "heightTransition", "onChangeEnd"]), k = this.state, N = k.height, H = k.fullyClosed, B = k.renderInner, U = B ? M.createElement("div", {
          ref: this._inner,
          style: {
            overflow: t && N === "auto" ? "visible" : "hidden"
          }
        }, W) : null;
        return M.createElement("div", (0, i.default)({}, z, {
          ref: this._main,
          style: {
            height: N,
            overflow: t && N === "auto" ? "visible" : "hidden",
            display: H && !p ? "none" : null,
            transition: "height ".concat(D)
          }
        }), U);
      }
    }], [{
      key: "_visibleWhenClosed",
      value: function(p) {
        return p.eagerRender || parseFloat(p.collapsedHeight) !== 0;
      }
    }, {
      key: "getDerivedStateFromProps",
      value: function(p, d) {
        return p.expanded && (d.closing || d.fullyClosed) ? {
          closing: !1,
          fullyClosed: !1,
          renderInner: !0
        } : !p.expanded && (d.closing || d.fullyClosed) && d.height !== p.collapsedHeight ? {
          height: p.collapsedHeight,
          renderInner: d.renderInner || I._visibleWhenClosed(p)
        } : null;
      }
    }]), I;
  }(M.Component);
  e.default = q, (0, b.default)(q, "propTypes", {
    expanded: w.default.bool.isRequired,
    onChangeEnd: w.default.func,
    collapsedHeight: w.default.string,
    heightTransition: w.default.string,
    className: w.default.string,
    allowOverflowWhenOpen: w.default.bool,
    eagerRender: w.default.bool
  }), (0, b.default)(q, "defaultProps", {
    collapsedHeight: "0",
    heightTransition: ".25s ease",
    className: "",
    allowOverflowWhenOpen: !1,
    eagerRender: !1
  });
})(Ne);
const gr = /* @__PURE__ */ Qe(Ne);
function qr(e) {
  const {
    children: { label: s, field: o, error: i },
    showError: r
  } = e;
  return /* @__PURE__ */ ge(Ee, { width: "100%", children: [
    /* @__PURE__ */ ge(Ze, { space: "small", children: [
      s,
      o
    ] }),
    /* @__PURE__ */ Te(Ee, { paddingTop: r ? "small" : "none", children: /* @__PURE__ */ Te(gr, { expanded: r, children: i }) })
  ] });
}
export {
  qr as default
};
